import { render, staticRenderFns } from "./PersonnelManagement.vue?vue&type=template&id=28ac421f&scoped=true&"
import script from "./PersonnelManagement.vue?vue&type=script&lang=js&"
export * from "./PersonnelManagement.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelManagement.vue?vue&type=style&index=0&id=28ac421f&lang=scss&scoped=true&"
import style1 from "./PersonnelManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac421f",
  null
  
)

export default component.exports